module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAG1BMVEX////IEC7KysrGCCfOKEP33uL66evOK0bzy9ErfBN/AAAA20lEQVR42u3YuwkCARBF0cHAfK3AbwMqmKsVCIKhPViDfRuY7UbDJCOeW8DjxC/WLYtlFJu/hlGnZxSbYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWH9AGt3L/a4jFnHd3XzFttrtWFSefIcm0O1Kas8uY/V0LAFFtY3rExYmbAyYWXCyoSVCSsTViasTFiZsDJhZcLK9D+sprdb05Oy6aXb9ADHwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwurPWrfsA7ZMcULnsjzGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/45.png
// module id = bncx
// module chunks = 1